<template>
    <div class="topicview">
        <div v-if="this.$parent.topicsUpdated">{{ buildTopiclist() }}</div>    
        <ul>
            <li class="topicviewitems" v-for="item in this.get_topics()" :key="item.id">
                <div v-if="item.id != -1 || $mode=='ms'">
                    <router-link :to="route(item.id, item.top)">{{item.label}}</router-link>
                </div>
            </li>
        </ul>
        <div id='advertise-overview' v-if='advertise && advertise.overview && $ms.hasElements(advertise.overview)'>            
            <Adslider id='adslider-overview' :ads='advertise.overview' :speed='parseInt(advertise.overview[0].speed) || 10' :postId='0'></Adslider>
        </div> 
    </div>
</template>

<script>
import Adslider from './Adslider.vue'
import MS_CONST from '../msclasses/msconst.js'

export default {
    name: "Topicview",
    components: {
        Adslider
    },
    props: {        
    },
    data() {
        return {
            menuitems: [
                { label: '[Themen noch nicht geladen]', id: 'n', top: false, subtopiclist: [] }
            ],
            topics: [],
            advertise: {}
        };
    },
    created() {
        this.buildTopiclist();        
        if (this.$leseapp.useads)
            this.get_advertising();
    },
    updated() {
        if (!this.$ms.hasElements(this.advertise) && this.$leseapp.useads)
            this.get_advertising();
    },
    methods: {
        buildTopiclist() {
            var self = this;
            self.$parent.topicsUpdated = false;
            this.$ms.loadCacheLogin(function(login) {
                if (login && login.topiclist) {                        
                    self.$log.debug('Build topic items.');
                    self.menuitems = [];                        
                    login.topiclist.forEach(function(item) {                            
                        var subtopics = [];
                        item.subtopiclist.forEach(function(subitem) {
                            subtopics.push({ label: subitem.list_label, id: subitem.list_id, top: item.list_id });
                            self.$parent.topicheaders[subitem.list_id] = subitem.list_label;
                        });
                        if (item.list_id == -1) 
                            item.list_label = MS_CONST.LABEL_ALLTOPICS
                        self.menuitems.push({ label: item.list_label, id: item.list_id, top: false, subtopics: subtopics });
                        self.$parent.topicheaders[item.list_id] = item.list_label;
                    });
                }
                else    
                    self.$log.debug('Keine Topicliste');
            });
        },
        get_topics() {
            var self = this;
            var menuitem = [];
            if (self.$parent.$route.params.topid) {
                self.menuitems.forEach(function (item) {
                    if (item.id == self.$parent.$route.params.topid) {
                        menuitem = item.subtopics;
                        self.$parent.setBacklink('/');
                    }
                });
            }
            else {
                menuitem = self.menuitems;
                self.$parent.setBacklink('');
            }
            return menuitem;
        },
        openMenuItem(id) {
            this.$log.debug("test " + id);
        },
        route(id, top) {
            if (top)
                return "/top/" + top + '/sub/' + id;
            return "/top/" + id;
        },
        get_advertising() {
            var self = this;
            // Lade Anzeigendaten und speichere sie in den Cache
            if (self.$ms.isOnline()){
                self.$ms.apiAdvertising(self, function(err, data) {
                    if (!err) {                            
                        self.advertise = data;
                        // In den Cache speichern
                        self.$log.debug('advertising data from web saved to cache');    
                        self.$ms.saveCacheAdvertise(data);
                    }
                    else
                        self.$log.warn('get_advertising - msAxios meldet: ' + error);                        
                });
            }
        }
    }
};
</script>

<style lang="css" src="../assets/css/Topicview.css"/>